export default __webpack_public_path__ + "static/Vector-00fb578dcd1123b024c6c7c9d424aca8.png";